// extracted by mini-css-extract-plugin
export default {"top":"savingCompanies_top__u-2ji","imageProfile":"savingCompanies_imageProfile__Qe9+V"};